<template>
  <div class="wrap">

<!--    <p class="fz12 text-gray">Checklists</p>-->
    <async-select
        v-if="false"
        :isChecklists="true"
        class="mt4"
        :is-multiple="true"
        v-model="checkList"
        placeholder=""
        url="/checklist"
        :allow-empty="true"
        :params="{is_archived: false, vessels: selectedVessel}"
        @input="changeCheckSelect"
    ></async-select>
    <checklist-lists :isDetailTask="true" :checkList="idTask ? [idTask] : []"></checklist-lists>
    <div class="no-checklists" v-if="getTaskInfo && !getTaskInfo.checklists.length">
      <svg width="75" height="74" viewBox="0 0 75 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.2214 0.595033C32.7478 0.208281 33.3843 0 34.0374 0H40.8934C41.5738 0 42.2353 0.225973 42.7729 0.642954L49.4402 5.81349C49.7341 6.04148 49.9803 6.31808 50.1704 6.62739C50.4614 7.10081 50.6212 7.65106 50.6212 8.22088V9.71396C50.6212 11.4033 49.2462 12.7643 47.5606 12.7643H26.9545C25.2689 12.7643 23.8939 11.4033 23.8939 9.71396V9.41419H16.1364C14.1233 9.41419 12.5 11.0366 12.5 13.0275V68.3867C12.5 70.3776 14.1233 72 16.1364 72H57.8636C59.8767 72 61.5 70.3776 61.5 68.3867V13.0275C61.5 11.0366 59.8767 9.41419 57.8636 9.41419C57.3114 9.41419 56.8636 8.96647 56.8636 8.41419C56.8636 7.8619 57.3114 7.41419 57.8636 7.41419C60.9718 7.41419 63.5 9.92263 63.5 13.0275V68.3867C63.5 71.4915 60.9718 74 57.8636 74H16.1364C13.0282 74 10.5 71.4915 10.5 68.3867V13.0275C10.5 9.92264 13.0282 7.41419 16.1364 7.41419H24.0122C24.094 7.12989 24.2166 6.85938 24.3758 6.61116C24.5755 6.29985 24.8327 6.02351 25.1385 5.79884L32.2214 0.595033ZM34.0374 2C33.8095 2 33.588 2.07274 33.4055 2.20679L26.3226 7.4106C26.2166 7.4885 26.128 7.58384 26.0593 7.6909C25.9524 7.85756 25.8939 8.05238 25.8939 8.25415V9.71396C25.8939 10.2893 26.3641 10.7643 26.9545 10.7643H47.5606C48.1511 10.7643 48.6212 10.2893 48.6212 9.71396V8.22088C48.6212 8.02612 48.5667 7.83763 48.4665 7.67467C48.4012 7.56833 48.3164 7.47294 48.2145 7.39393L41.5473 2.22339C41.361 2.07892 41.1309 2 40.8934 2H34.0374ZM28.4361 22.5738C28.8257 22.9653 28.8241 23.5985 28.4326 23.988L24.1163 28.2828C23.1227 29.2715 21.5137 29.2715 20.52 28.2828L19.2947 27.0636C18.9032 26.674 18.9016 26.0408 19.2911 25.6494C19.6807 25.2579 20.3138 25.2563 20.7053 25.6458L21.9307 26.8651C22.1441 27.0775 22.4922 27.0775 22.7056 26.8651L27.0219 22.5703C27.4134 22.1808 28.0466 22.1823 28.4361 22.5738ZM33.9394 26.8673C33.9394 26.315 34.3871 25.8673 34.9394 25.8673H44.7273C45.2796 25.8673 45.7273 26.315 45.7273 26.8673C45.7273 27.4196 45.2796 27.8673 44.7273 27.8673H34.9394C34.3871 27.8673 33.9394 27.4196 33.9394 26.8673ZM49.9091 26.8673C49.9091 26.315 50.3568 25.8673 50.9091 25.8673H51.9394C52.4917 25.8673 52.9394 26.315 52.9394 26.8673C52.9394 27.4196 52.4917 27.8673 51.9394 27.8673H50.9091C50.3568 27.8673 49.9091 27.4196 49.9091 26.8673ZM22.8333 38.6316C21.1048 38.6316 19.7121 40.0245 19.7121 41.7323C19.7121 43.44 21.1048 44.8329 22.8333 44.8329C24.5618 44.8329 25.9545 43.44 25.9545 41.7323C25.9545 40.0245 24.5618 38.6316 22.8333 38.6316ZM17.7121 41.7323C17.7121 38.9105 20.0097 36.6316 22.8333 36.6316C25.657 36.6316 27.9545 38.9105 27.9545 41.7323C27.9545 44.554 25.657 46.8329 22.8333 46.8329C20.0097 46.8329 17.7121 44.554 17.7121 41.7323ZM33.9394 41.7323C33.9394 41.18 34.3871 40.7323 34.9394 40.7323H51.9394C52.4917 40.7323 52.9394 41.18 52.9394 41.7323C52.9394 42.2845 52.4917 42.7323 51.9394 42.7323H34.9394C34.3871 42.7323 33.9394 42.2845 33.9394 41.7323ZM22.8333 54.0092C21.1048 54.0092 19.7121 55.4021 19.7121 57.1098C19.7121 58.8176 21.1048 60.2105 22.8333 60.2105C24.5618 60.2105 25.9545 58.8176 25.9545 57.1098C25.9545 55.4021 24.5618 54.0092 22.8333 54.0092ZM17.7121 57.1098C17.7121 54.2881 20.0097 52.0092 22.8333 52.0092C25.657 52.0092 27.9545 54.2881 27.9545 57.1098C27.9545 59.9316 25.657 62.2105 22.8333 62.2105C20.0097 62.2105 17.7121 59.9316 17.7121 57.1098ZM33.9394 57.1098C33.9394 56.5576 34.3871 56.1098 34.9394 56.1098H51.9394C52.4917 56.1098 52.9394 56.5576 52.9394 57.1098C52.9394 57.6621 52.4917 58.1098 51.9394 58.1098H34.9394C34.3871 58.1098 33.9394 57.6621 33.9394 57.1098Z" fill="#BDCBD6"/>
      </svg>
      <p class="text-align-center mt16 text-dark fz14">Checklists are not linked to the vessel.<br> Select checklists manually or link the vessel <br> to checklists in the checklist settings.</p>
    </div>
  </div>
</template>

<script>
import ChecklistLists from "@/components/checklist/checklist-lists";
import {mapGetters} from "vuex";
import AsyncSelect from "@/components/reuse/asyncSelect";
export default {
  name: "check-list-detailt-task",
  components: {AsyncSelect, ChecklistLists},
  computed: {
    ...mapGetters(['getTaskInfo']),
  },
  props: {
    idTask: null,
  },
  watch: {

  },
  data() {
    return {

    }
  },
  methods: {
    openCheckList() {

    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .wrap {
    position: relative;
  }
  .no-checklists {
    margin-top: 26%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .open-edit-checklist-button {
    position: absolute;
    top: 0;
    right: 0;
  }
  /deep/ {
    .add-title::after {
      transform: translateX(calc(-100% - 13px));
    }
  }
</style>